/**
 * Generated accessibility labels for the SVG roots (role="img").
 */
import type { XaCategorical, XaSlice } from './types.js';
import { fmt } from './format.js';

/**
 * e.g. "Stacked bar chart, 14 categories, 3 series: Input tokens, Output tokens, Reasoning tokens".
 */
export function categoricalAriaLabel(kind: string, data: XaCategorical): string {
  const cats = data.categories.length;
  const names = data.series.map((s) => s.name).join(', ');
  const n = data.series.length;
  return `${kind} chart, ${cats} ${cats === 1 ? 'category' : 'categories'}, ${n} ${n === 1 ? 'series' : 'series'}: ${names}`;
}

/**
 * e.g. "Donut chart, 5 slices: GPT-4o 4.2M, Claude Sonnet 4.5 3.1M, …".
 */
export function sliceAriaLabel(kind: string, data: XaSlice[]): string {
  const parts = data.map((d) => `${d.label} ${fmt(d.value)}`).join(', ');
  return `${kind} chart, ${data.length} ${data.length === 1 ? 'slice' : 'slices'}: ${parts}`;
}
